; function CommentsLsAjaxCRUD() {
    const DOMDisplay = CommentsLsDOMDisplay();

    const CSRF = $('meta[name="csrf-token"]').attr("content");
    const HTTP_METHOD = {
        GET: "get",
        POST: "post",
    };
    const REQUEST_STATUS = {
        SUCCESS: "success",
        ERROR: "error",
    };

    return {
        create(form) {
            $.ajax({url: form.attr("action"), method: HTTP_METHOD.POST, data: form.serializeArray(), dataType: "json"}).done((request) => {
                if (request.status === REQUEST_STATUS.SUCCESS) {
                    const fieldName = form.find("#new-comment-name"),
                        fieldMessage = form.find("#new-comment-message"),
                        fieldEmail = form.find("#new-comment-email"),
                        buttonSubmit = form.find("button[type=submit]"),
                        commentListFirstUl = form.closest(".comments").find(".comment-list > ul");

                    commentListFirstUl.prepend(request.view);
                    fieldMessage.val("");
                    DOMDisplay.fieldHide(fieldName);
                    DOMDisplay.fieldHide(fieldEmail);
                    buttonSubmit.prop("disabled", true);
                }
            });
        },

        answer() {

        },

        update(form) {
            $.ajax({url: form.attr("action"), method: HTTP_METHOD.POST, data: form.serializeArray(), dataType: "json"}).done((request) => {
                if (request.status === REQUEST_STATUS.SUCCESS) {
                    const fieldMessage = form.find("#new-comment-message"),
                        buttonSubmit = form.find("button[type=submit]"),
                        liContainer = form.closest("li");

                    liContainer.replaceWith(request.view);
                    fieldMessage.val("");
                    buttonSubmit.prop("disabled", true);
                }
            });
        },

        delete(btn, comment, byId) {
            const url = btn.attr("href");
            const data = {
                _csrf: CSRF,
                id: byId,
            };

            $.ajax({url: url, method: HTTP_METHOD.POST, data: data, dataType: "json"}).done((request) => {
                if (request.status === REQUEST_STATUS.SUCCESS) {
                    comment.remove();
                }
            });
        },
    }
}
